        export class HazardFakeDb
        {
        public static hazards = [
        {  
        'SiteId':'1000001',
        'ClientId':'1',
        'AccountNum':'429699',
        'SiteType':'Fire Commercial',
        'Company':'BRANDYWINE PORCHE',
        'Address':'4005 WEST CHESTER PKE',
        'PremideID':'12698',
        'HazardID':'1231',
        'SerialNo':'596561',
        'DeviceStatus':'Installed',
        'InstalledDate':'02/12/1987',
        'Serial':'441325',
        'Manufacturer':'WATTS',
        'Model':'DC40',
        'Type':'RP',
        'Size':'1.75',
        'Location':'IN ISLAND OF OLD YORK & BERREL AVE.',
        'Location2':'F.B. IN OLD YORK ISLAND -RT OF 1857DRV.',
        'LeadFree':'1',
        'Orient':'1',
        'InstalledOn':'02/03/2017',
        'InstalledRepairDueDate':'Wedenedday 30th May 2018',
        'ScheduleDate':'Wedenedday 30th May 2018',
        'NoticeSent':'Sent',
        'Notice1':'Sent',
        'Notice2':'Sent',
        'Notice3':'None',
        'Notice4':'None',
        'RemoveRepairDueDate':'',
        'ExtendedDueDate':'',
        'Recommendations':'tokay hazard',
        'Notes':'Test',
        'Category':'Category 1',
	'Customer':'BRANDYWINE',
	'SvcPntId':'1',
'Priority':'Medium',
'ServClass':'service',
'Protection':'Protection',
'TestMonts':'Test Monts',
'Seasonal':'Seasonal',
'HeatType':'HeatType',
'Meter':'59055115',
'LineSize':'8 Inch',
'LineStatus':'Active',
'Tap':'Tap  1',
'Link':'M20101019',
'Device':'Watts	007M1QT DC',
'MeterLocation':'BERREL',
'LastDate':'02/03/2018',
'LastLetter':'02/03/2018',
'LinkCode':'true',
'UDH':'SRII 5/8 X 3/4',
'ShutOffDate':'02/03/2018'
        },
        {  
        'SiteId':'1000001',
        'ClientId':'2',
        'AccountNum':'91573',
        'SiteType':'Fire Commercial',
        'Company':'JOHN MIDDLETON',
        'Address':'416 MORRIS AVE',
        'PremideID':'12699',
        'HazardID':'1232',
        'SerialNo':'596562',
        'DeviceStatus':'Installed',
        'InstalledDate':'03/12/1987',
        'Serial#':'441325',
        'Manufacturer':'WATTS',
        'Model':'DC40',
        'Type':'RP',
        'Size':'1.75',
        'Location':'IN ISLAND OF OLD YORK & BERREL AVE.',
        'Location2':'F.B. IN OLD YORK ISLAND -RT OF 1857DRV.',
        'LeadFree':'1',
        'Orient':'',
        'InstalledOn':'02/03/2017',
        'InstalledRepairDueDate':'Wedenedday 30th May 2018',
        'ScheduleDate':'Wedenedday 30th May 2018',
        'NoticeSent':'Sent',
        'Notice1':'Sent',
        'Notice2':'Sent',
        'Notice3':'None',
        'Notice4':'None',
        'RemoveRepairDueDate':'',
        'ExtendedDueDate':'',
        'Recommendations':'tokay hazard',
        'Notes':'Test',

        },
        {  
        'SiteId':'1000001',
        'ClientId':'3',
        'AccountNum':'91574',
        'SiteType':'Fire Commercial',
        'Company':'JOHN MIDDLETON',
        'Address':'416 MORRIS AVE',
        'PremideID':'12691',
        'HazardID':'1233',
        'SerialNo':'596563',
        'DeviceStatus':'Installed',
        'InstalledDate':'04/12/1987',
        'Serial#':'441325',
        'Manufacturer':'WATTS',
        'Model':'DC40',
        'Type':'RP',
        'Size':'1.75',
        'Location':'IN ISLAND OF OLD YORK & BERREL AVE.',
        'Location2':'F.B. IN OLD YORK ISLAND -RT OF 1857DRV.',
        'LeadFree':'1',
        'Orient':'',
        'InstalledOn':'02/03/2017',
        'InstalledRepairDueDate':'Wedenedday 30th May 2018',
        'ScheduleDate':'Wedenedday 30th May 2018',
        'NoticeSent':'Sent',
        'Notice1':'Sent',
        'Notice2':'Sent',
        'Notice3':'None',
        'Notice4':'None',
        'RemoveRepairDueDate':'',
        'ExtendedDueDate':'',
        'Recommendations':'tokay hazard',
        'Notes':'Test',

        },
        {  
        'SiteId':'1000001',
        'ClientId':'4',
        'AccountNum':'91574',
        'SiteType':'Fire Commercial',
        'Company':'JOHN MIDDLETON',
        'Address':'416 MORRIS AVE',
        'PremideID':'12692',
        'HazardID':'1234',
        'SerialNo':'596565',
        'DeviceStatus':'Installed',
        'InstalledDate':'04/12/1987',
        'Serial#':'441325',
        'Manufacturer':'WATTS',
        'Model':'DC40',
        'Type':'RP',
        'Size':'1.75',
        'Location':'IN ISLAND OF OLD YORK & BERREL AVE.',
        'Location2':'F.B. IN OLD YORK ISLAND -RT OF 1857DRV.',
        'LeadFree':'1',
        'Orient':'',
        'InstalledOn':'02/03/2017',
        'InstalledRepairDueDate':'Wedenedday 30th May 2018',
        'ScheduleDate':'Wedenedday 30th May 2018',
        'NoticeSent':'Sent',
        'Notice1':'Sent',
        'Notice2':'Sent',
        'Notice3':'None',
        'Notice4':'None',
        'RemoveRepairDueDate':'',
        'ExtendedDueDate':'',
        'Recommendations':'tokay hazard',
        'Notes':'Test',

        },
        ];

        }
